import LZString from "lz-string";
import * as z from "../../../../framework";
import { Widget } from "./widget";

export var W_HTML = function (widgetInstance?) {
    widgetInstance = widgetInstance || {};
    this.HTML = widgetInstance.HTML || "";

    var widget = new Widget(widgetInstance);
    $.extend(this, widget);

    this.init();
};

W_HTML.prototype = {
    init: function () {
        var me = this,
            html;

        if (me.HTML) {
            html = me.HTML;
        }

        if (!html && me.options && me.options.HTML) {
            html = me.options.HTML;
        }

        if (!html && localStorage.Widgets) {
            var widgets = $.parseJSON(LZString.decompressFromUTF16(localStorage.Widgets));
            var widget = widgets[me.widgetId] || {};
            html = widget.HTML;
        }

        if (html) {
            me.contents.append(html);
        } else {
            z.ajax({
                type: "GET",
                url: `Widget/?ID=${me.widgetId}`
            }).done(function (response) {
                var options = JSON.parse(response.d.results.Options);
                widgets[me.widgetId] = options;
                localStorage.setItem("Widgets", LZString.compressToUTF16(JSON.stringify(widgets)));
                me.contents.append(options.HTML);
            });
        }
    }
};
